import { firebaseConfigured } from "./firebase.js";
import { firebaseStore } from "./firebaseStore.js";
import { demoStore } from "./demoStore.js";

export const store = firebaseConfigured ? firebaseStore : demoStore;
export const usingDemoData = !firebaseConfigured;
